<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">
          <div class="settings-header">
            Credit Cards Accounts
            <div class="settings-header__btn">
              <el-button type="success" size="mini" @click="routerLink('settings-dashboard')">Setting Dashboard</el-button>
            </div>
          </div>
          <el-table
              max-height="600"
              :data="tableData"
              :empty-text="$t('general_noData')"
              style="width: 100%">
            <el-table-column
                label="ID"
                type="index"
                width="50">
            </el-table-column>
            <el-table-column
                prop="name"
                label="Account Name">
            </el-table-column>
            <el-table-column
                :label="$t('settings_accountThink_taxTypes_accountGroup')">
              <template slot-scope="scope">
                {{scope.row.group.name}}
              </template>
            </el-table-column>
            <el-table-column
                width="200"
                :label="$t('settings_accountThink_taxTypes_currentBalance')">
              <template slot-scope="scope">
                {{formatPrice(scope.row.creditCardAccount.currentBalance)}}
              </template>
            </el-table-column>
            <el-table-column
                width="200"
                :label="$t('settings_accountThink_taxTypes_openingBalance')">
              <template slot-scope="scope">
                {{formatPrice(scope.row.creditCardAccount.openingBalance)}}
              </template>
            </el-table-column>
            <el-table-column
                width="100"
                :label="$t('settings_accountThink_taxTypes_currency')">
              <template slot-scope="scope">
                {{scope.row.currencyName}}
              </template>
            </el-table-column>
            <el-table-column
                :label="$t('settings_accountThink_taxTypes_createDate')"
                width="150">
              <template slot-scope="scope">
                {{moment(scope.row.createdDate).format('D MMM YY') }}
              </template>
            </el-table-column>
            <el-table-column
                width="120"
                :label="$t('settings_accountThink_taxTypes_operations')">
              <template slot-scope="scope">
                <el-button
                    size="mini"
                    type="primary"
                    plain
                    icon="el-icon-edit"
                    @click="handleEdit(scope.$index, scope.row)"></el-button>
                <el-button
                    size="mini"
                    type="danger"
                    plain
                    icon="el-icon-delete"
                    @click="handleDelete(scope.$index, scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <EditCreditCardAccountModal ref="editModal" @loadList="loadList" />
  </div>
</template>

<script>
import axios from "axios";
import moment from 'moment'
import EditCreditCardAccountModal
  from "@/components/settings/settingsCreditCardAccounts/EditCreditCardAccountModal.vue";
export default {
  name: "CreditCardsAccounts",
  components: {EditCreditCardAccountModal},
  data() {
    return {
      tableData: [],
      moment: moment
    }
  },
  mounted() {
    this.loadList()
  },
  methods: {
    loadList() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .get(`/api/v1/account/accountOnlyCreditCard?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.tableData = response.data.list
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
    },
    handleEdit(index, row) {
      this.$refs.editModal.openModal(row)
    },
    handleDelete(index, row) {
      console.log(index, row)
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    routerLink(page) {
      this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
    },
  }
}
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>
